import React, { useDeferredValue, useState } from "react";
import PageHeader from "../../components/PageHeader";
import { Link } from "react-router-dom";

import DataTable from "react-data-table-component";
import { customTableStyles, deleteConfirmation } from "../../utils";
import { Button, Collapse, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import EditCompanyModal from "./edit";
import AddCompanyModal from "./Add";
import ViewModal from "./View";
import Filter from "./Filter";
import useLiveDataTable from "../../hooks/useLiveDataTable";
import {
  useGetBrokerQuery,
  useRemoveBrokerMutation,
} from "../../redux/services/BrokerService";
import CustomPagination from "../../components/CustomPagination";
import {
  useGetFactoryCompanyQuery,
  useMarkAsDefaultMutation,
  useRemoveFactoryCompanyMutation,
} from "../../redux/services/FactoryCompanyService";
const FactoringCompaniesPage = () => {
  const {
    currentPage,
    perPage,
    q,
    searchQuery,
    setSearchQuery,
    handlePageChange,
    handlePerPageChange,
    handleSearchChange,
    onSearchKeyHandler,
    handleSearchBy,
    searchBy,
  } = useLiveDataTable();

  const [selectedRow, setSelectedRow] = useState(null);
  const [isShow, setIsShow] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isView, setIsView] = useState(false);
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState(null);
  const params = useDeferredValue(query);

  const [removeRequest] = useRemoveFactoryCompanyMutation();
  const [markAsDefaultRequest] = useMarkAsDefaultMutation()

  const {
    data: data2,
    isFetching,
    refetch,
  } = useGetFactoryCompanyQuery({
    pagination: `?page=${currentPage}&per_page=${perPage}&search_by=${searchBy}&search=${q}${
      params?.id ? "&created_at=" + params?.id : ""
    }`,
  });
  const drivers = data2?.response?.data?.data;
  const total = data2?.response?.data?.total;

  const handleAdd = () => {
    setIsEdit(null);
    setIsShow(true);
    // reset()
  };

  const handleEdit = (items) => {
    setIsEdit(items);
    setIsShow(true);
  };

  const handleView = (items) => {
    setIsEdit(items);
    setIsView(true);
  };

  return (
    <>
      <PageHeader name="Factoring Company" />
      <div className="main-container container-fluid">
        {" "}
        {/* Start::row-1 */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card custom-card">
              <div className="card-header w-100">
                <div className="row w-100 m-0">
                  <div className="col-auto p-0 d-flex">
                    <Button
                      className="btn btn-primary"
                      onClick={() => setIsShow(true)}
                    >
                      Add Company
                    </Button>
                  </div>
                  <div className="col-auto p-0 ms-2">
                    <Button
                      className="btn btn-primary"
                      onClick={() => setOpen(!open)} // Toggle collapse
                      aria-controls="collapse-inputs"
                      aria-expanded={open}
                    >
                      <i className="ri-filter-2-fill" />
                    </Button>
                  </div>
                  <div className="col-lg-3 col-5 p-0 ms-auto">
                    <div className="input-group m-0">
                      <span
                        className="input-group-text bg-transparent border text-primary"
                        id="basic-addon1"
                      >
                        <i className="ri-search-line" />
                      </span>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Search Here..."
                        aria-describedby="basic-addon1"
                        value={searchQuery}
                        onKeyUp={(e) => onSearchKeyHandler(e)}
                        onChange={(e) => setSearchQuery(e.target?.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <Collapse in={open}>
                <div className="w-100">
                  <Filter setQuery={setQuery} />
                </div>
              </Collapse>
              <div className="card-body">
                <CustomPagination
                  isFetching={isFetching}
                  data={drivers}
                  total={total}
                  onChangePage={handlePageChange}
                  onChangeRowsPerPage={handlePerPageChange}
                  paginationDefaultPage={currentPage}
                  columns={[
                    {
                     name: (
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id="default-tooltip">
                              This will make this factoring company as default
                              factoring company when assigning loads. This will
                              be auto-selected when you assign a load to save
                              time.
                            </Tooltip>
                          }
                        >
                          <span className="cursor-pointer d-flex gap-1 align-items-center">
                            Default <i className="ri-information-line ms-1" />
                          </span>
                        </OverlayTrigger>
                      ),
                      cell: (row) => (
                        <div className="d-flex justify-content-center w-100">
                        <div
                          className={`custom-radio-checkbox ${
                            (selectedRow === row?.id || Number(row?.is_default) === 1) ? "checked" : ""
                          }`}
                          onClick={() => {
                            setSelectedRow(row?.id)
                            markAsDefaultRequest(row?.id)
                          }}
                        >
                          <div className="checkmark" />
                        </div>
                        </div>
                      ),
                      width: "100px",
                    },
                    {
                      name: "Company Name",
                      selector: (row) => row.company_name,
                      sortable: true,
                    },
                    {
                      name: "Email",
                      selector: (row) => row.email,
                      sortable: true,
                    },
                    {
                      name: "Phone",
                      selector: (row) => row.phone,
                      sortable: true,
                    },
                    {
                      name: "Description",
                      selector: (row) => row.description,
                      sortable: true,
                    },
                    {
                      name: "Created At",
                      selector: (row) => row.created_at,
                      sortable: true,
                    },
                    {
                      name: "Actions",
                      cell: (row) => {
                        return (
                          <div className="hstack gap-1 fs-1">
                            <button
                              aria-label="view"
                              onClick={() => handleView(row)}
                              className="btn btn-icon btn-sm btn-primary-light btn-wave waves-effect waves-light"
                            >
                              <i className="ri-eye-fill" />
                            </button>
                            <button
                              aria-label="edit"
                              // onClick={() => navigate(`/jobs/edit/${row?.id}`, { state: { isEdit: row } })}
                              onClick={() => handleEdit(row)}
                              className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                            >
                              <i className="ri-edit-line" />
                            </button>
                            <a
                              aria-label="delete"
                              onClick={() =>
                                deleteConfirmation(() => removeRequest(row?.id))
                              }
                              className="btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light"
                            >
                              <i className="ri-delete-bin-7-line" />
                            </a>
                          </div>
                        );
                      },
                      ignoreRowClick: true,
                      allowOverflow: true,
                      button: true,
                      width: "220px",
                    },
                  ]}
                />
              </div>
            </div>

            {isShow && (
              <AddCompanyModal
                show={isShow}
                handleClose={() => {
                  setIsShow(false);
                  setIsEdit(null);
                }}
                isEdit={isEdit}
              />
            )}

            {isView && (
              <ViewModal
                show={isView}
                handleClose={() => {
                  setIsView(false);
                  setIsEdit(null);
                }}
                isEdit={isEdit}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default FactoringCompaniesPage;
